import { ReactNode, useEffect, useState } from "react";

interface ProgressiveImageProps {
    src: string;
    placeholder: string;
    delay: number;
    srcSetData: {
        srcSet: string;
        sizes: string;
    };
    children: (src: string, loading: boolean, srcSetData: { srcSet: string; sizes: string }) => ReactNode;
}

export default function ProgressiveImageComponent({
    src,
    placeholder = "",
    delay,
    srcSetData = { srcSet: "", sizes: "" },
    children,
}: ProgressiveImageProps) {
    const [loading, setLoading] = useState(true);
    const [currentSrc, setCurrentSrc] = useState(placeholder);
    const img = new Image();

    useEffect(() => {
        const loadImage = () => {
            img.onload = () => {
                setCurrentSrc(src);
                setLoading(false);
            };
            img.onerror = () => {
                setCurrentSrc(placeholder);
                setLoading(false);
            };

            img.src = src;

            if (srcSetData.srcSet) {
                img.srcset = srcSetData.srcSet;
            }
        };

        if (delay > 0) {
            const timer = setTimeout(loadImage, delay);
            return () => {
                clearTimeout(timer);
                img.onload = null;
                img.onerror = null;
            };
        } else {
            loadImage();
        }

        return () => {
            img.onload = null;
            img.onerror = null;
        };
    }, [src, delay, srcSetData.srcSet]);

    return <>{children(currentSrc, loading, srcSetData)}</>;
}
